<template>
  <div>
    <van-nav-bar title="个人中心" ></van-nav-bar>

    <!--<section class="animation_opactiy backOpacity shop_back_svg_container" v-if="showLoading">-->
      <!--<img src="../../../images/shop_back_svg.svg">-->
    <!--</section>-->
    <!--<loading v-show="showLoading"></loading>-->

    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>

    <date-picker></date-picker>
    <footerView></footerView>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { NavBar } from 'vant';
  import { Swipe, SwipeItem } from 'vant';
  import { Image } from 'vant';
  import { Grid, GridItem } from 'vant';
  import { Lazyload } from 'vant';
  import { Tabbar, TabbarItem } from 'vant';
  import { Toast } from 'vant';
  import loading from '@/components/page/common/loading.vue'
  import datePicker from '@/components/page/common/Datepicker.vue';

  import footerView from '../common/footer'

  Vue.use(NavBar);
  Vue.use(Swipe).use(SwipeItem);
  Vue.use(Image);
  Vue.use(Grid).use(GridItem);
  Vue.use(Lazyload);
  Vue.use(Tabbar).use(TabbarItem);
  Vue.use(Toast);


  export default {
    name: 'mine',
    data () {
      return {
        showLoading:true,
        images: [
          'http://www.hellokittypark.cn/shared/images/event/event2.jpg',
          'http://www.hellokittypark.cn/shared/images/bbx/up3.jpg'
        ],
        topImg:[
          'http://www.hellokittypark.cn/shared/images/bbx/up4.jpg'
        ],
        testImg:[
          'http://www.hellokittypark.cn/shared/images/bbx/up1.jpg',
          'http://www.hellokittypark.cn/shared/images/bbx/up2.jpg'
        ],
        goodsList:[
          'http://www.hellokittypark.cn/shared/images/bbx/up1.jpg',
          'http://www.hellokittypark.cn/shared/images/bbx/up2.jpg',
          'http://www.hellokittypark.cn/shared/images/bbx/up3.jpg',
          'http://www.hellokittypark.cn/shared/images/bbx/up4.jpg',
        ],
        active: 0,
        icon: {
          normal: '//img.yzcdn.cn/icon-normal.png',
          active: '//img.yzcdn.cn/icon-active.png'
        }
      }
    },

    methods: {

      onClickRight() {
        Toast('跳转会员码');
        this.$router.push('mine');
      },

    },

    components: {
      loading,
      footerView,
      datePicker
    },

    created() {

    },

    mounted() {

      console.log(this.showLoading);

      setTimeout(function(){

        this.showLoading = false;

        console.log(this.showLoading);

      }, 3000);

    },

    beforeDestroy() {

    },

    destroyed() {

    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .shop_back_svg_container{
    position: fixed;
    width:100%;
    height: 100%;
  }

  .shop_back_svg_container img {
    width: 100%;
    height: 100%;
  }

  @keyframes backOpacity{
    0%   { opacity: 1 }
    25%  { opacity: .5 }
    50%  { opacity: 1 }
    75%  { opacity: .5 }
    100% { opacity: 1 }
  }

  .animation_opactiy{
    animation: backOpacity 2s ease-in-out infinite;
  }


</style>



// WEBPACK FOOTER //
// src/components/page/mine/mine.vue